// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SendFilledIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24.139 11.345 12.662 5.638c-7.71-3.84-10.874-.693-7.012 6.974l1.166 2.32c.335.68.335 1.466 0 2.146L5.65 19.385c-3.862 7.667-.71 10.813 7.012 6.973l11.477-5.706c5.148-2.56 5.148-6.747 0-9.307Zm-4.331 5.653h-7.24a1.01 1.01 0 0 1-1.006-1c0-.546.456-1 1.006-1h7.24c.55 0 1.006.454 1.006 1 0 .547-.456 1-1.006 1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
